export default {
  PUSH: "push",
  ORDER: "order",
  GIFT_GOODS: "gift_goods",
  CHANGE_DELIVERY_ZONE: "change_delivery_zone",
  ORDER_DELIVERED: "order_delivered",
};
